import { ErrorHandler as AngularErrorHandler } from '@angular/core';

export class DefaultErrorHandler implements AngularErrorHandler {
  handleError(error: unknown): void {
    console.error(error);
  }
}
